import { useFavorite } from "src/hooks/FavoriteContext";
import request from "@libs/request/request";
import { inject, observer } from "mobx-react";
import { useEffect } from "react";

const FavoriteOffersLoader = inject("CoreStore")(
  observer(({ CoreStore }) => {
    const { favoriteOffers, setFavoriteOffers } = useFavorite();

    useEffect(() => {
      const now = new Date();
      const storedFavorites = JSON.parse(
        localStorage.getItem("favoriteOffers")
      );

      if (storedFavorites) {
        const storedExpireAt = new Date(storedFavorites.expire_at);
        if (now < storedExpireAt) {
          setFavoriteOffers(storedFavorites);
          return;
        }
      }

      if (CoreStore?.isAuth !== "1") {
        return;
      }

      const expireAt = new Date(favoriteOffers?.expire_at);
      if (
        !favoriteOffers.ids.length ||
        !favoriteOffers.expire_at ||
        now >= expireAt
      ) {
        request
          .get("user/profile/wishlist/item/ids")
          .then((response) => {
            const data = response?.data;
            setFavoriteOffers(data);
            CoreStore.updateFavoriteOffers(data?.expire_at, data?.ids);
          })
          .catch((error) => {
            console.error("Error fetching favorite offers:", error);
          });
      }
    }, [CoreStore?.isAuth]);

    return null;
  })
);

export default FavoriteOffersLoader;
